module.exports = __webpack_public_path__ + "img/Indiana-University-logo.5b71d08c.png";